import React from "react"

const ClipRoundedSlantDefs = () => (
  <svg aria-hidden="true" focusable="false" style={{ position: "absolute", width: 0, height: 0 }}>
    <defs>
      <clipPath id="clipRoundedSlant" clipPathUnits="objectBoundingBox">
        <path d="M0,0.26 C0,0.187 0.0304,0.127 0.0699,0.1216 L0.918,0.0004 C0.963,0.0000 1,0.0578 1,0.1387 V1 H0 V0.26 Z" />
      </clipPath>
    </defs>
  </svg>
)

export default ClipRoundedSlantDefs
